import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import { defineRole, defineRoleCenterSite } from "../handleAccessRoles";
import { ROLE_EQUIPMENT } from "../../constants/ROLES";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchEquipments = async (
  lng = "english",
  {
    page,
    limit,
    dropdownType,
    id,
    department,
    q,
    center,
    centerSite,
    status,
    type,
    code,
  }
) => {
  try {
    const { centerRole } = await defineRoleCenterSite();

    const user = await getStorage();

    if (!dropdownType) {
      const canAccess = defineRole({
        roles: user.accessRole,
        menu: ROLE_EQUIPMENT,
        operation: "read,readOnAction",
      });
      if (!canAccess) return;
    }

    const options = {
      method: "GET",
      url: `${API_URL}/equipment`,
      params: {
        page: page,
        limit: limit,
        id,
        department,
        q,
        center: center || centerRole,
        centerSite,
        status,
        type,
        code: code && code !== "" ? code : undefined,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    if (dropdownType === "dropdown") {
      const items = Array.isArray(queryRes.data?.data)
        ? queryRes.data.data
        : Array.isArray(queryRes.data)
        ? queryRes.data
        : [];
      return items.map((el) => ({
        ...el,
        label: el.code + " - " + el.name,
        value: el._id,
      }));
    }

    let { data, count, totalRecords } = queryRes.data;

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    console.log(error);
    toastMessage("error", error);
  }
};

export const deleteEquipment = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_EQUIPMENT,
      operation: "delete",
    });

    if (!canAccess) return;

    const options = {
      method: "DELETE",
      url: `${API_URL}/equipment`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_equipment);
  } catch (error) {
    toastMessage("error", error);
  }
};
